import {
  Component,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';

import {
  BehaviorSubject,
  combineLatest,
  concatMap,
  debounceTime,
  distinctUntilChanged,
  map,
  of,
  Subscription,
} from 'rxjs';
import { WkIdType } from 'app/shared/constants/wkid.constant';

import { PortugalWkidService } from 'app/shared/services/portugal-wkid.service';
import { EsriUtils } from 'app/shared/utils/esri.utils';

@Component({
  selector: 'app-projection',
  templateUrl: 'projection.component.html',
  styleUrls: ['projection.component.scss'],
})
export class ProjectionComponent implements OnDestroy, OnChanges {
  @Input()
  mapView: __esri.MapView;

  mapProjection: __esri.Point;

  private mapViewSubscription: Subscription;

  constructor(private portugalWkidService: PortugalWkidService) { }

  ngOnDestroy(): void {
    this.mapViewSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mapView) {
      this.handleMapView();
    }
  }

  @HostListener('click')
  onHostClick() {
    this.portugalWkidService.setWgs84Mode()
  }

  private handleMapView() {
    this.mapViewSubscription?.unsubscribe();
    if (!this.mapView) {
      return;
    }

    const pointerMoveObservable = EsriUtils.on(
      this.mapView,
      'pointer-move'
    ).pipe(
      map((e) => this.mapView.toMap(e)),
      debounceTime(0)
    );

    this.mapViewSubscription = combineLatest(
      pointerMoveObservable,
      this.portugalWkidService.onWgs84ModeToggle.pipe(distinctUntilChanged()),
      this.portugalWkidService.getAreaGeomList()
    )
      .pipe(
        concatMap(([point, wgs84Mode]) => {
          if (wgs84Mode) {
            return of(EsriUtils.project(point, { wkid: WkIdType.WKID4326 }));
          }

          return this.portugalWkidService.projectGeomToAreaWkid(point);
        })
      )
      .subscribe((point) => {
        this.mapProjection = point;
      });
  }
}
